import React, {useContext, useState} from "react";
import {DraftContext} from "../draftSave/context/DraftSaveContext";
import {getTestConfigKey} from "../util/Util";
import Row from "@amzn/meridian/row";
import Modal, {ModalFooter} from "@amzn/meridian/modal";
import {getLocalizedMessage} from "../util/Localization";
import Text from "@amzn/meridian/text";
import Column from "@amzn/meridian/column";
import Select, {SelectOption} from "@amzn/meridian/select";
import Button from "@amzn/meridian/button";
import Icon from "@amzn/meridian/icon";
import trashTokens from "@amzn/meridian-tokens/base/icon/trash";
import escapeRegExp from "lodash/escapeRegExp"
import {injectIntl} from "react-intl";

const DeleteTestPackageConfigurationModel = (props) => {

    const {getDraftData, deleteInstance, deleteAll} = useContext(DraftContext);
    const {open, setOpen, mac, intl, testConfig} = props;
    const [selectedScannables, setSelectedScannables] = useState("")
    const [searchQuery, setSearchQuery] = useState("")

    const scannableKeyList = getDraftData({
        stateKey: testConfig,
        subKey: mac
    }).map(({scannables}) => getTestConfigKey(scannables));

    const searchRegExp = new RegExp(escapeRegExp(searchQuery), "i")
    const matchedKeys = scannableKeyList.filter(
        option => !searchQuery || searchRegExp.test(option)
    )

    const deleteData = () => {
        deleteInstance({
            stateKey: testConfig,
            subKey: mac,
            keyComparator: (instance) => getTestConfigKey(instance.scannables) === selectedScannables
        });
    }

    const onClickConfirm = () => {
        deleteData();
        setOpen(false)
        resetInputState();
    }

    function resetInputState() {
        setSelectedScannables("");
    }

    const onCloseModal = () => {
        setOpen(false);
        resetInputState();
    }

    return (
        <Row>
            <Modal
                title={getLocalizedMessage({intl, stringId: "stowtestconfig.deleteconfig"})}
                open={open}
                onClose={onCloseModal}
                scrollContainer="viewport"
                closeLabel="Close"
                bodySpacingInset="medium">
                <Text tag="label" type="b200" color="primary" htmlFor="my-input">
                    {getLocalizedMessage({intl, stringId: "modal.delete_test_package"})}
                </Text>
                <Column spacing={"medium"} spacingInset={"medium"}>
                    <Select
                        value={selectedScannables}
                        onChange={setSelectedScannables}
                        searchQuery={searchQuery}
                        onSearch={setSearchQuery}
                        placeholder={getLocalizedMessage({intl, stringId: "stowtestconfig.delete"})}
                        width="100%">
                        {matchedKeys.map((scannable) =>
                            <SelectOption key={scannable} value={scannable} label={scannable}/>
                        )}
                        {!matchedKeys.length ? (
                            <Column alignmentVertical="center" spacing="100" spacingInset="100">
                                {scannableKeyList ?
                                    <Text alignment="center">
                                        {getLocalizedMessage({intl, stringId: "testconfig.nomatch"})}
                                    </Text>
                                    : <Text alignment="center">
                                        {getLocalizedMessage({intl, stringId: "testconfig.notavailable"})}
                                    </Text>
                                }
                            </Column>) : null}
                    </Select>
                </Column>
                <ModalFooter>
                    <Row alignmentHorizontal="justify" widths="fit">
                        <Button
                            size="small"
                            className="redBtn"
                            onClick={() => {
                                deleteAll({stateKey: testConfig, subKey: mac});
                                onCloseModal();
                            }}>
                            <Icon tokens={trashTokens} />
                            {getLocalizedMessage({intl, stringId: "modal.deleteAll"})}
                        </Button>
                        <Row alignmentHorizontal="right" widths="fit">
                            <Button type="secondary" size="small" onClick={onCloseModal}>
                                {getLocalizedMessage({intl, stringId: "modal.cancel"})}
                            </Button>
                            <Button type="primary" size="small" onClick={onClickConfirm}>
                                {getLocalizedMessage({intl, stringId: "modal.confirm"})}
                            </Button>
                        </Row>
                    </Row>
                </ModalFooter>
            </Modal>
        </Row>
    )

}

export default injectIntl(DeleteTestPackageConfigurationModel)


// WEBPACK FOOTER //
// ./src/components/commonui/DeleteTestPackageConfigurationModal.js